import React from "react"
import Label from "components/Label"
import { useLocale } from "context/locale"
import CriticalPlanetStateIcon from "icons/critical_planet_state.svg"
import ClothesBransIcon from "icons/clothes_brands.svg"
import TakeResponsibilityIcon from "icons/take_responsibility.svg"

import StyledMotivation from "./styles"

const Motivation = () => {
  const { t } = useLocale()
  return (
    <StyledMotivation id="why">
      <div className="main-container">
        <div className="motivation-container">
          <header className="motivation-header">
            <Label text="#people" />
            <h2 className="title h1">{t("Our motivation")}</h2>
            <p className="desc">
              {t(
                "Ecology is not a passing trend. We are aware of how the clothing industry affects the planet. We take responsibility for our impact."
              )}
            </p>
          </header>
          <div className="motivation-boxes">
            <div className="motivation-box">
              <div className="box-image">
                <CriticalPlanetStateIcon />
              </div>
              <div className="box-text">
                <p
                  className="bolder"
                  dangerouslySetInnerHTML={{
                    __html: t("Critical condition <br /> of the planet"),
                  }}
                />
              </div>
            </div>
            <div className="motivation-box">
              <div className="box-image">
                <ClothesBransIcon />
              </div>
              <div className="box-text">
                <p
                  className="bolder"
                  dangerouslySetInnerHTML={{
                    __html: t("The impact of <br /> fashion brands"),
                  }}
                />
              </div>
            </div>
            <div className="motivation-box">
              <div className="box-image">
                <TakeResponsibilityIcon />
              </div>
              <div className="box-text">
                <p
                  className="bolder"
                  dangerouslySetInnerHTML={{
                    __html: t("We take <br /> responsibility"),
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </StyledMotivation>
  )
}

export default Motivation
